// extracted by mini-css-extract-plugin
export default {"tasks":"AO-z","task":"BO-z","svg":"CO-z","text":"DO-z"};